import React, { useEffect, useRef, useState } from 'react';
import './../../../Styles/Payment/PaymentSuccess.css';
import TopMenuBar from '../../../Components/Layouts/TopMenuBar';
import SideMenuBar from '../../../Components/Layouts/SideMenuBar';
import RightSideBar from '../../../Components/Layouts/RightSideBar';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import trackorder from '../../../assets/svg/TrackOrder.svg';
import enjoyreels from '../../../assets/svg/enjoyReel.svg';
import axiosVendorInstance from '../../../axiosVendorInstance';
import { Helmet } from 'react-helmet';
import { SEO } from '../../../Utils/Constant';

function PaymentSuccess() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const location = useLocation();
    const { orderId } = location.state || {};
    const [orderStatusText, setOrderStatusText] = useState(null);
    const initialStatusRef = useRef(null);

    useEffect(() => {
        window.scrollTo(0, 0);

        let pollingInterval;

        const fetchInvoiceData = async () => {
            try {
                const response = await axiosVendorInstance.get(
                    `/Order/user/orderinvoice/${orderId}`,
                    { skipAuth: true }
                );
                const status = response?.data?.invoice?.[0]?.['0']?.Invoice_Details?.Status_Text;
                if (status && status !== orderStatusText) {
                    setOrderStatusText(status);
                }
                return status;
            } catch (error) {
                console.error('Error fetching order invoice:', error);
            }
        };

        if (orderId) {
            fetchInvoiceData();

            // Start polling every 20 seconds
            pollingInterval = setInterval(fetchInvoiceData, 20000);
        }

        const handleVisibilityChange = async () => {
            if (document.visibilityState === 'visible' && orderId) {
                const newStatus = await fetchInvoiceData();
                if (newStatus && newStatus !== initialStatusRef.current) {
                    window.location.reload(); // Refresh the page
                }
            }
        };
        document.addEventListener('visibilitychange', handleVisibilityChange);
        return () => {
            clearInterval(pollingInterval);
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [orderId, orderStatusText]);


    return (
        <div>
            <Helmet>
                <title>{SEO.PAYMENT_SUCCESS_PAGE.TITLE}</title>
            </Helmet>
            <div className="topmenubar">
                <SideMenuBar />
                <div className="top-bar-mobile">
                    <TopMenuBar/>
                </div>
            </div>

            {orderStatusText === 'order_rejected' && (
                navigate('/PaymentFail')
            )}
            {orderStatusText !== 'order_rejected' && (
                <div className="payment-success-svg-text">
                    <div className="payment-success">
                        <div className="zoom-container">
                            <svg
                                width="210"
                                height="210"
                                viewBox="0 0 210 210"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <circle
                                    cx="105"
                                    cy="105"
                                    r="105"
                                    fill="#02A750"
                                    fillOpacity="0.09"
                                />
                                <path
                                    d="M105 17.5C56.7875 17.5 17.5 56.7875 17.5 105C17.5 153.213 56.7875 192.5 105 192.5C153.213 192.5 192.5 153.213 192.5 105C192.5 56.7875 153.213 17.5 105 17.5ZM146.825 84.875L97.2125 134.488C95.9875 135.713 94.325 136.413 92.575 136.413C90.825 136.413 89.1625 135.713 87.9375 134.488L63.175 109.725C60.6375 107.188 60.6375 102.987 63.175 100.45C65.7125 97.9125 69.9125 97.9125 72.45 100.45L92.575 120.575L137.55 75.6C140.088 73.0625 144.288 73.0625 146.825 75.6C149.363 78.1375 149.363 82.25 146.825 84.875Z"
                                    fill="#02A750"
                                />
                            </svg>
                        </div>

                        <p className="order-message">
                            <span className="successfully-placed-span">
                            Thank you!
                            </span><br/>
                        Your order has been placed.
                        </p>

                        <p className="thankyou-message">
                            {orderStatusText === 'order_placed'
                                ? 'Waiting for the restaurant to accept.'
                                : 'Order Accepted — Track it live below.'
                            }
                        </p>

                        <div className="share-container" onClick={() => navigate('/reels')}>
                            <p className="share-order-text">{t('payment.enjoy-reels')}</p>

                            <div className="verticle-line-and-svg">
                                <span className="success-verticle-line"></span>
                                <img src={enjoyreels} alt="enjoyreels" />
                            </div>
                        </div>

                        <Link to={`/orders/${orderId}`}>
                            <div className="success-location-track-container">
                                <p className="track-order-text">{t('payment.track-your-order')}</p>

                                <div className="verticle-line-and-svg">
                                    <span className="success-track-verticle-line"></span>
                                    <img src={trackorder} alt="trackorder" />
                                </div>
                            </div>
                        </Link>
                    </div>
                </div>
            ) }

            <RightSideBar/>
        </div>
    );
}

export default PaymentSuccess;
